import { FC, SVGProps } from "react";

export const TradingLeftNavIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  const { width = 24, height = 24, ...rest } = props;
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className="oui-text-base-contrast-54"
      {...rest}
    >
      <path
        d="M5.426 1.66663C5.24175 1.67715 4.98875 1.75081 4.85308 1.85868C4.80817 1.89464 4.67798 2.0148 4.65323 2.05076L1.02049 7.28121C0.892158 7.44872 0.833496 7.67235 0.833496 7.80916C0.833496 8.18539 1.09108 8.41167 1.09108 8.41167L9.28423 18.0043C9.28973 18.0113 9.58307 18.3393 10.0002 18.3332C10.4172 18.3262 10.7106 18.0113 10.7161 18.0043C10.9718 17.7053 18.9404 8.37835 18.9404 8.37835C18.9404 8.37835 19.1668 8.08015 19.1668 7.80916C19.1668 7.53729 18.9486 7.23472 18.9486 7.23472L15.3571 2.05338C15.3315 2.01742 15.2728 2.0297 15.2426 1.99901C15.2059 1.95691 15.2013 1.89728 15.1564 1.86132C15.0207 1.75345 14.8603 1.74292 14.6981 1.7245C14.6541 1.71836 14.6284 1.67013 14.5835 1.67013H14.4973L5.426 1.66663ZM7.36474 3.42414H12.6356L10.0002 6.43841L7.36474 3.42414ZM5.50299 4.02664L8.05224 6.93216H3.46891L5.50299 4.02664ZM14.4973 4.02664L16.5314 6.93216H11.9481L14.4973 4.02664ZM3.69808 8.68616H9.08349V14.9892L3.69808 8.68616ZM10.9168 8.68616H16.3022C15.0235 10.1806 12.4999 13.1387 10.9168 14.9892V8.68616Z"
        fill="currentColor"
      />
    </svg>
  );
};
